import React from 'react';
import { RouteComponentProps } from "react-router-dom";
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import WHTransferErpList from 'components/Inventory/WarehouseTransferErpList';
import WHTransferErpListPrint from 'components/Inventory/WarehouseTransferErpList/PrintPickList';
import WHTransferErpListQueue from 'components/Inventory/WarehouseTransferErpList/QueuePickList';
import WHTransferErpListScan from 'components/Inventory/WarehouseTransferErpList/ScanToSubmit';

type Props = RouteComponentProps & {
  page?: 'queue' | 'print' | 'scan';
};

const WarehouseTransferErpList = (props: Props) => {
  let Component = null;

  switch(props.page) {
    case 'print':
      Component = WHTransferErpListPrint;
      break;

    case 'queue':
      Component = WHTransferErpListQueue;
      break;

    case 'scan':
      Component = WHTransferErpListScan;
      break;

    default:
      Component = WHTransferErpList;
  }

  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        {Component && <Component />}
      </SiteContent>
    </ContentLayout>
  );
};

export default WarehouseTransferErpList;
